import { render, staticRenderFns } from "./TaskPane.vue?vue&type=template&id=a8add7ba&scoped=true&lang=pug"
import script from "./TaskPane.vue?vue&type=script&lang=js"
export * from "./TaskPane.vue?vue&type=script&lang=js"
import style0 from "./TaskPane.vue?vue&type=style&index=0&id=a8add7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8add7ba",
  null
  
)

export default component.exports